import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'purchaseUnits',
  initialState: null as null | string[],
  reducers: {
    setPurchaseUnits(state, action: PayloadAction<string[]>) {
      return action.payload;
    },
  },
});

export const { setPurchaseUnits } = slice.actions;
export default slice.reducer;
